<template lang="pug">
#bloco-dados-area-plantio-certificacao
    h2.titulo-bloco-dados-area-plantio-certificacao Dados de área de plantio
    .dados-area-plantio-certificacao__linha
        .dados-area-plantio-certificacao__cartao(v-if='funcionalidadeAtiva')
            .lyra__cartao
                .lyra-cartao-conteudo-interno
                    .area-plantio-certificacao-card
                        .area-plantio-certificacao-card__titulo
                            span.area-plantio__titulo Total
                        .area-plantio-certificacao-card__informacoes
                            .area-plantio-certificacao-card-soja
                                i.lyra-icon.lyra-soja
                                span.area-plantio-span(
                                    icon='lyra-icon lyra-soja'
                                ) {{ formatters.formatNumberUs(dadosTotal.areaSoja) }} ha
                            .area-plantio-certificacao-card-milho(
                                v-if='funcionalidadeAtiva'
                            )
                                i.lyra-icon.lyra-milho
                                span.area-plantio-span {{ formatters.formatNumberUs(dadosTotal.areaMilho) }} ha

        .dados-area-plantio-certificacao__cartao(
            v-for='(dados, index) in dadosCertificacoes',
            :key='index'
        )
            .lyra__cartao
                .lyra-cartao-conteudo-interno
                    .area-plantio-certificacao-card
                        .area-plantio-certificacao-card__titulo
                            span.area-plantio__titulo Elegível a {{ dados.tipo }}
                        .area-plantio-certificacao-card__informacoes
                            .area-plantio-certificacao-card-soja
                                i.lyra-icon.lyra-soja
                                span.area-plantio-span(
                                    icon='lyra-icon lyra-soja'
                                ) {{ formatters.formatNumberUs(dados.areaSoja) }} ha
                            .area-plantio-certificacao-card-milho(
                                v-if='dados.areaMilho != null'
                            )
                                i.lyra-icon.lyra-milho
                                span.area-plantio-span {{ formatters.formatNumberUs(dados.areaMilho) }} ha
</template>

<script>
import formatters from '@/utils/formatters';
export default {
    name: 'BlocoDadosAreaPlantio',

    props: {
        dadosAreaPlantio: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            formatters,
            dadosTotal: {
                areaSoja: null,
                areaMilho: null
            },
            dadosCertificacoes: [
                {
                    tipo: null,
                    areaSoja: null,
                    areaMilho: null
                }
            ],
            funcionalidadeAtiva: false
        };
    },

    watch: {
        dadosAreaPlantio: function () {
            this.dadosTotal = this.dadosAreaPlantio.itens.filter(item => {
                return item.tipo === 'Total';
            });
            this.dadosCertificacoes = this.dadosAreaPlantio.itens.filter(
                item => {
                    return item.tipo !== 'Total';
                }
            );
        }
    },

    methods: {},

    mounted() {}
};
</script>

<style lang="scss" scoped>
#bloco-dados-area-plantio-certificacao {
    .titulo-bloco-dados-area-plantio-certificacao {
        font-weight: bold;
        margin-bottom: 1rem;
        margin-top: 1rem;
    }
    .dados-area-plantio-certificacao__linha {
        flex-wrap: wrap;
        display: flex;
        gap: 8px;
        margin-bottom: 8px;
        gap: 20px;

        & > .dados-area-plantio-certificacao__cartao {
            flex-grow: 1;
        }

        .dados-area-plantio-certificacao__cartao {
            display: flex;
            flex-direction: column;
            height: 100%;
        }

        .lyra__cartao {
            display: grid;
            grid-template-columns: 1fr 2fr;
            flex: 1 1 30%;
            align-items: flex-start;
            display: flex;

            flex-direction: column;
            flex: 1 1 30%;
            gap: 16px;
            padding: 16px;
            min-height: 82px;

            .lyra-cartao-conteudo-interno {
                display: flex;
                gap: 8px;
                width: 100%;
                justify-content: space-between;

                .area-plantio-certificacao-card {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    justify-content: space-between;
                    min-height: 50px;
                }
            }

            .area-plantio__titulo {
                font-size: 14px;
                font-weight: bold;
            }

            .area-plantio-certificacao-card__informacoes {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 10px;
                flex-wrap: wrap;
                width: 100%;

                .area-plantio-certificacao-card-soja,
                .area-plantio-certificacao-card-milho {
                    display: flex;
                    gap: 4px;

                    .area-plantio-span {
                        font-size: 14px;
                        font-weight: bold;
                        color: var(--primary);
                    }
                }
            }
        }
    }
}
.dados-area-plantio-certificacao__linha:last-child {
    margin-bottom: 0;
}

@media only screen and (max-width: 1334px) {
    .dados-area-plantio-certificacao__cartao {
        min-width: 45% !important;
        -webkit-box-flex: 0;
    }
}
</style>
